const INFO = {
	main: {
		title: "Web Dev - Woodrow Reese",
		name: "Woodrow Reese",
		email: "woodrow7reese@gmail.com",
		number: "(978) 241-5709",
		logo: "./logo.png",
		location: "Haverhill, MA"
	},

	socials: {
		github: "https://github.com/wooooocoder",
		linkedin: "https://linkedin.com/in/reese-woodrow",
		discord: "https://discordapp.com/users/w.o.o.d.y_"
	},

	homepage: {
		title: "Full Stack Web Developer",
		description:
			"I am a web developer with an extensive practice using MongoDB, Express.js, React, and Node.js. I have delivered solutions for 15 clients with pre-existing codebases using technologies such as the MERN stack, Java Spring, Shopify, Excel, SQL, and Wordpress. Passionate about developing applications, delivering top-notch solutions and growing my skillset in the process. I am always open to new opportunites and contributing to unique projects!",
	},

	about: {
		title: "My name is Woodrow Reese, and I am driven to develop software!",
		description:
			"With 4 years of experience, I have exposed myself to a variety of technologies! I am a rising senior at the University of Massachusetts - Boston, and completing a BS of Computer Science in December 2024. I am involved in Computer Science Club and Chess Club. If you're interested in any of the projects Ive worked on, please check out my github, I'd love to collaborate or recieve your feedback! I'm always open to new ideas.",
		hobbies: "Outside of the practice, I enjoy rock climbing, chess, paintballing, snowboarding and building my car.",
	},

	articles: {
		title: "I'm passionate about pushing the boundaries of what's possible and inspiring the next generation of innovators.",
		description:
			"Chronological collection of my long-form thoughts on programming, leadership, product design, and more.",
	},

	projects: [
		{
			title: "YelpCamp",
			description:
				"Yelp, but for campsites. Share, View and Create reviews of campsites all around the world!",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
			linkText: "View Project",
			link: "https://mighty-earth-55463-b132356ca8f0.herokuapp.com/",
		},

		{
			title: "Boulder Flash",
			description:
				"Track your rock climbing process with Boulder Flash. Create a session and log your climbs. Upload videos of them, share them, and generate statistics of your progress!",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
			linkText: "View Project",
			link: "https://github.com/woodrow7reese/woodrow7reese.github.io",
		},

	],
};

export default INFO;
